import type { MyTicketView } from '@mopla/ticketshop-api';

import { deriveTicketCategory } from '../../operatorTickets/hooks';
import { IMyTicket } from '../types';

/**
 * Map the BE `MyTicketView` DTO to the internal app model.
 * BE fields are optional in the generated types, so required app fields are
 * defaulted defensively (mirrors `mapOperatorDto`).
 * The operator logo comes straight from the BE-provided `operatorIconUrl`; the
 * card renders no logo when it is absent.
 */
export const mapMyTicketDto = (dto: MyTicketView): IMyTicket => ({
	purchaseId: dto.purchaseId ?? '',
	ticketName: dto.ticketName ?? '',
	operatorName: dto.operatorName ?? '',
	// BE dropped `ticketType`; derive the class the detail view still uses.
	ticketType: deriveTicketCategory(dto),
	billingMode: dto.billingMode,
	periodCount: dto.periodCount,
	status: dto.status,
	validFrom: dto.validFrom,
	validUntil: dto.validUntil,
	zoneCodes: (dto.zones ?? [])
		.map((zone) => zone.zoneCode ?? '')
		.filter(Boolean),
	wholeNetwork: dto.wholeNetwork ?? false,
	entryStopName: dto.entryStopName,
	priceInCents: dto.priceInCents,
	priceGroupName: dto.priceGroupName,
	discounted: dto.discounted,
	operatorIconUrl: dto.operatorIconUrl,
});
